/* Warenkorb-Titel aus Metafeld – 7 O'CLOCK (angelegt 04.10.2026, Alina)
   Im Warenkorb-Drawer zeigt das Theme den Shopify-Produkttitel („Beige Musselin Einzelbettwäsche | Haven").
   Hier wird er durch den Anzeigetitel aus custom.titel ersetzt – wie auf Karten und Produktseite.
   Quelle: window.ocCartTitles (snippets/7oc-cart-titles.liquid); fehlt ein Produkt, wird der Titel
   einmalig über /products/<handle>?view=oc-titel nachgeladen und für die Sitzung gemerkt.
   Format: „Musselin Einzelbettwäsche Beige 135×200cm, Haven" → letztes Komma wird zu „ | " wie im Theme-Titel.
   Eingebunden global über snippets/gtm-head.liquid. */
(function () {
  'use strict';
  var map = window.ocCartTitles || {};
  var pending = {};
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('oc-cart-titles') || '{}') || {}; } catch (e) {}

  function fmt(t) {
    var i = t.lastIndexOf(',');
    if (i > 0 && i < t.length - 1) return t.slice(0, i).trim() + ' | ' + t.slice(i + 1).trim();
    return t;
  }
  function titleFor(handle) { return map[handle] || cache[handle] || null; }

  function fetchTitle(handle) {
    if (pending[handle] || typeof fetch !== 'function') return;
    pending[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '?view=oc-titel', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (txt) {
        if (!txt) return;
        var t; try { t = JSON.parse(txt.trim()); } catch (e) { return; }
        if (typeof t !== 'string') return;
        cache[handle] = t || ''; /* leer merken, damit nicht erneut geladen wird */
        try { sessionStorage.setItem('oc-cart-titles', JSON.stringify(cache)); } catch (e) {}
        apply();
      })
      .catch(function () {});
  }

  /* Handle des Artikels: aus dem Alpine-Scope (product.handle), sonst aus einem Produktlink */
  function handleOf(item) {
    try {
      if (window.Alpine && typeof Alpine.$data === 'function') {
        var d = Alpine.$data(item);
        if (d && d.product && d.product.handle) return d.product.handle;
      }
    } catch (e) {}
    var a = item.querySelector('a[href*="/products/"]');
    if (a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (m) return m[1]; }
    return null;
  }

  function apply() {
    var items = document.querySelectorAll('.mini-cart_item');
    for (var i = 0; i < items.length; i++) {
      var el = items[i].querySelector('.mini-cart_item-title');
      if (!el) continue;
      var h = handleOf(items[i]);
      if (!h) continue;
      var t = titleFor(h);
      if (t === null) { fetchTitle(h); continue; }
      if (!t) continue; /* kein Anzeigetitel gepflegt → Theme-Titel bleibt */
      var want = fmt(t);
      if (el.textContent !== want) el.textContent = want;
    }
  }

  var raf = null;
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; apply(); }); }

  function init() {
    apply();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
